import Service from "../Service";
import AuthService from "../AuthService";

const Meeting = {
  getMeetingList(page) {
    return AuthService.get(
      "/api/get-current-paginate-meeting?page=" + page
    ).then((res) => {
      return res;
    });
  },
  getAllMeetingList(page) {
    return AuthService.get("/api/get-all-paginate-meeting?page=" + page).then(
      (res) => {
        return res;
      }
    );
  },
  getSubMeetingList(page) {
    return AuthService.get(
      "/api/get-all-paginate-meeting-post?page=" + page
    ).then((res) => {
      return res;
    });
  },
  getMeeting(id) {
    return AuthService.get(`/api/meeting/${id}`).then((res) => {
      return res;
    });
  },
  getSubMeet(id) {
    return AuthService.get(`/api/meeting-post/${id}`).then((res) => {
      return res;
    });
  },
  getSubMeetForView(id) {
    return AuthService.get(`/api/show-for-view-meeting-post/${id}`).then(
      (res) => {
        return res;
      }
    );
  },
  getMeetForView(id) {
    return AuthService.get(`/api/show-for-view-meeting/${id}`).then(
      (res) => {
        return res;
      }
    );
  },
  getAllMeeting(page) {
    return AuthService.get(`/api/meeting?page=` + page).then((res) => {
      return res;
    });
  },
  getAllMeetingAttendees(data) {
    return AuthService.get(
      `/api/get-join-meeting-by-id?page=${data.page}&meetingID=${data.meetingID}`
    ).then((res) => {
      return res;
    });
  },
  getMeetingAttendees(data) {
    if (data.meetingStatus === undefined) {
      data.meetingStatus = "";
    }
    if (data.meetingID === undefined) {
      data.meetingID = "";
    }
    if (data.name === null) {
      data.name = "";
    }
    return AuthService.get(
      `/api/get-meeting-attendees?page=${data.page}&meetingID=${data.meetingID}&reviewerName=${data.name}&meetingStatus=${data.meetingStatus}`
    ).then((res) => {
      return res;
    });
  },
  getSearchMeetingAttendees(data) {
    return AuthService.get(
      `/api/get-join-meeting-by-name?page=${data.page}&meetingID=${data.meetingID}&reviewerName=${data.name}`
    ).then((res) => {
      return res;
    });
  },
  getMeetList() {
    return AuthService.get(`/api/get-all-meeting-for-select`).then((res) => {
      return res;
    });
  },
  getSubMeetList() {
    return AuthService.get(`/api/get-all-meeting-post-for-select`).then((res) => {
      return res;
    });
  },
  save(data) {
    return AuthService.post("/api/meeting", data).then((res) => {
      return res;
    });
  },
  reviewSave(data) {
    return AuthService.post("/api/review-save", data).then((res) => {
      return res;
    });
  },
  saveSubMeeting(data) {
    return AuthService.post("/api/meeting-post", data).then((res) => {
      return res;
    });
  },
  delete(id) {
    return AuthService.delete(`/api/meeting/${id}`).then((res) => {
      return res;
    });
  },
  update(data, id) {
    let formData = new FormData();
    formData.append("meetingName", data.meetingName);
    formData.append("meetingNumber", data.meetingNumber);
    formData.append("meetingYear", data.meetingYear);
    formData.append("meetingDate", data.meetingDate);
    formData.append("meetingTime", data.meetingTime);
    formData.append("meetingEndTime", data.meetingEndTime);
    formData.append("firstAgendaFile", data.firstAgendaFile ? data.firstAgendaFile : '');
    formData.append("fourthAgendaResult", data.fourthAgendaResult ? data.fourthAgendaResult : '');
    formData.append("meetingPlace", data.meetingPlace ? data.meetingPlace : '');
    formData.append("secondAgenda", data.secondAgenda ? data.secondAgenda : '');
    formData.append("secondAgendaFile", data.secondAgendaFile ? data.secondAgendaFile : '');
    formData.append("thirdAgenda", data.thirdAgenda ? data.thirdAgenda : '');
    formData.append("thirdAgendaFile", data.thirdAgendaFile ? data.thirdAgendaFile : '');
    formData.append("eleventhAgenda", data.eleventhAgenda ? data.eleventhAgenda : '');
    formData.append("eleventhAgendaFile", data.eleventhAgendaFile ? data.eleventhAgendaFile : '');
    formData.append("hasSeventh", data.hasSeventh ? data.hasSeventh : '0');
    formData.append("hasEighth", data.hasEighth ? data.hasEighth : '0');
    formData.append("hasNinth", data.hasNinth ? data.hasNinth : '0');
    formData.append("secondAgendaResult", data.secondAgendaResult ? data.secondAgendaResult : '0');
    formData.append("thirdAgendaResult", data.thirdAgendaResult ? data.thirdAgendaResult : '0');
    formData.append("result", data.result);
    formData.append("firstAgenda", JSON.stringify(data.firstAgenda));
    formData.append("fourthAgenda", JSON.stringify(data.fourthAgenda));
    formData.append("fifthAgenda", JSON.stringify(data.fifthAgenda));
    formData.append("sixthAgenda", JSON.stringify(data.sixthAgenda));
    formData.append("seventhAgenda", JSON.stringify(data.seventhAgenda));
    formData.append("eighthAgenda", JSON.stringify(data.eighthAgenda));
    formData.append("ninthAgenda", JSON.stringify(data.ninthAgenda));
    formData.append("tenthAgenda", JSON.stringify(data.tenthAgenda));
    formData.append("reviewers", JSON.stringify(data.reviewers));
    formData.append("reviewersNotJoin", JSON.stringify(data.reviewersNotJoin));
    formData.append("reviewersObserver", JSON.stringify(data.reviewersObserver));
    formData.append("reviewersDelete", JSON.stringify(data.reviewersDelete));

    return AuthService.post(`/api/update-meeting/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((res) => {
      return res;
    });
  },
  updateSubMeet(data, id) {
    console.log('save meeting data',data);
    return AuthService.post(`/api/update-meeting-post/${id}`, data).then((res) => {
      return res;
    });
  },
  filterMeeting(data) {
    return AuthService.get(
      "/api/filter-meeting?page=" + data.page + "&&year=" + data.year
    ).then((res) => {
      return res;
    });
  },
  filterSubMeeting(data) {
    return AuthService.get(
      "/api/filter-meeting-post?page=" + data.page + "&&year=" + data.year
    ).then((res) => {
      return res;
    });
  },
  searchMeetingAttendees(data) {
    return "Comming soon!";
    // return AuthService.get("/api/search-meeting?page="+data.page+"&&date="+data.date).then(res => {
    //     return res;
    // });
  },
  getJoinMeeting(id) {
    return AuthService.get(`/api/get-join-meeting/${id}`).then((res) => {
      return res;
    });
  },
  getCurrentMeetingSelect() {
    return AuthService.get(`/api/get-current-meeting-for-select`).then(
      (res) => {
        return res;
      }
    );
  },
  updateStatusMeeting(data) {
    return AuthService.post(`/api/join-meeting`, data).then((res) => {
      return res;
    });
  },
};

export default Meeting;
